import curry from './curry'

export const prop = curry((key, obj) => obj[key])
export const defaultTo = curry(
  (defaultValue, value) => (value == null ? defaultValue : value)
)



// WEBPACK FOOTER //
// ./src/utils/fp.js